import cx from 'classnames';
import { uniq } from 'lodash';
import capitalize from 'lodash/capitalize';
import lowerCase from 'lodash/lowerCase';
import React, { useMemo } from 'react';
import bt from '../bootstrap.module.css';
import icons from '../icons';
import Badge from './Badge';

const ComponentLabel = props => {
  const { data, isBuilder, isRegistersLoading, value } = props;

  const registerName = isRegistersLoading
    ? 'Loading...'
    : (props.registers || []).find(({ id }) => +id === +data.registerId)?.name || 'Deleted label';

  const registerBadge =
    !isBuilder &&
    data?.compliance &&
    (data?.registerId ? (
      <Badge type="info">Label: {registerName}</Badge>
    ) : (
      <Badge type="critical" prefix={<img alt="alert" width={16} src={icons.AlertWhite} />}>
        Label: Label not selected
      </Badge>
    ));

  const complianceStatuses = useMemo(() => {
    if (isBuilder || !data.compliance || !value || !value.length) {
      return [];
    }

    const valueArr = Array.isArray(value) ? value : [value];

    return (data.options || [])
      .filter(({ id }) => valueArr.includes(id))
      .map(({ compliance }) => compliance);
  }, []);

  if (!data.label) return null;
  return (
    <label
      className={cx('flex flex-wrap gap-3', props.className || bt['form-label'])}
      style={{
        marginBottom: 8,
      }}
    >
      <span className="font-semibold">{data.label}</span>
      {(isBuilder || registerBadge || data.required) && (
        <div className="flex flex-wrap gap-3 items-center print:hidden">
          {!isBuilder && data.required && <Badge type="warning">Required</Badge>}

          {registerBadge}
          {uniq(complianceStatuses).map(status => (
            <Badge type="info" key={status}>
              {capitalize(lowerCase(status))}
            </Badge>
          ))}
        </div>
      )}
    </label>
  );
};

export default ComponentLabel;
